export default "__VITE_ASSET__9CtVB5rZ__"